/* global plotline */
import { useNavigate } from "react-router-dom";
import { getPlatform } from "utils/config";

const usePlotline = () => {
  const apiKey = process.env.REACT_APP_PLOTLINE_API_KEY;
  const plotlineEnabled = !localStorage.adminToken; // disable for admin login

  const navigate = useNavigate();

  const initPlotline = (userId, handlePlotlineEventsData) => {
    if (apiKey && plotlineEnabled) {
      try {
        plotline("init", apiKey, userId);
        plotline("setPlotlineEventsListener", (eventName, properties) => {
          handlePlotlineEventsData(eventName, properties);
        });
        plotline("setRedirectListener", (json) => {
          if (json && json["NAVIGATE"]) {
            navigate(json["NAVIGATE"]);
          }
        });
        trackEventPlotline("session_start", {
          platform: getPlatform(),
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const trackEventPlotline = (eventName, params = {}) => {
    if (apiKey && plotlineEnabled) {
      try {
        plotline("track", eventName, params);
      } catch (error) {
        console.error("Plotline track event error:", error);
      }
    }
  };

  const setUserPropertiesPlotline = (params) => {
    if (!params || typeof params !== "object") return;
    if (apiKey && plotlineEnabled) {
      try {
        const updatedParams = Object.fromEntries(
          Object.entries(params)?.map(([key, value]) => [key, String(value)])
        );
        plotline("identify", updatedParams);
      } catch (error) {
        console.error("Plotline user properties error:", error);
      }
    }
  };

  return {
    initPlotline,
    trackEventPlotline,
    setUserPropertiesPlotline,
  };
};

export default usePlotline;
